module.exports = __webpack_public_path__ + "static/media/VIDEO-EXERGUE.4cabc191.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/VIDEO-EXERGUE.png
// module id = 291
// module chunks = 0